import React, { Component } from 'react'
import './errorPage.less'
import { Button } from 'antd'

export default class Page404 extends Component {
  render() {
    return (
      <div className="error-page-layout">
        <div className="error-img">
          <img src="/extendicon/img/404.png" style={{
            width: '521px',
            height: '490px'
          }} />
        </div>
        <div className="error-page-content">
          <div>
            <div className="error-page-font1-404">404</div>
            <div className="error-page-font2">很抱歉！您输入的URL有误</div>
            <div className="error-page-font3">如果您想继续访问，请联系管理员</div>
            <Button type="primary" style={{ marginBottom: '109px' }}>返回首页</Button>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/Demo/errorPage/Page404.tsx